"use client";

// src/utils/smooth/index.ts
import { useSmooth } from "./useSmooth.js";
import { useSmoothStatus, withSmoothContextProvider } from "./SmoothContext.js";
export {
  useSmooth,
  useSmoothStatus,
  withSmoothContextProvider
};
//# sourceMappingURL=index.js.map